import React from 'react';
import { Icon } from '@gerdau/hefesto/Icon';
import { Title } from '@gerdau/hefesto/Title';
import { HowWorks } from './styles';

const LoyaltyHowWorks: React.FC = () => {
  return (
    <HowWorks>
      <div className="icon-story-container">
        <div className="icon-story-container__item">
          <i>
            <Icon option="DollarSign" variant="primary" size="full" />
          </i>
          <Title level={4}>Acumule pontos com seus pedidos</Title>
        </div>
      </div>
      <div className="icon-story-container">
        <div className="icon-story-container__item">
          <i>
            <Icon option="CheckCircle2" variant="primary" size="full" />
          </i>
          <Title level={4}>
            No fechamento do mês, resgate seus pontos ou acumule para o próximo
            mês
          </Title>
        </div>
      </div>
      <div className="icon-story-container">
        <div className="icon-story-container__item">
          <i>
            <Icon option="Award" variant="primary" size="full" />
          </i>
          <Title level={4}>
            Acompanhe suas metas e simule o quanto você precisa para atingi-las
          </Title>
        </div>
      </div>
    </HowWorks>
  );
};

export default LoyaltyHowWorks;
